import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'gofre.Settings.Verifactu.connection.title',
  },
  text: { id: 'gofre.Settings.Verifactu.connection.text' },
  cta: { id: 'gofre.Settings.Verifactu.connection.cta' },
  ilustration01title: {
    id: 'gofre.Settings.Verifactu.connection.ilustration01.title',
  },
  ilustration01text: {
    id: 'gofre.Settings.Verifactu.connection.ilustration01.text',
  },
  ilustration02title: {
    id: 'gofre.Settings.Verifactu.connection.ilustration02.title',
  },
  ilustration02text: {
    id: 'gofre.Settings.Verifactu.connection.ilustration02.text',
  },
  ilustration03title: {
    id: 'gofre.Settings.Verifactu.connection.ilustration03.title',
  },
  ilustration03text: {
    id: 'gofre.Settings.Verifactu.connection.ilustration03.text',
  },
});

export const dialogVerifactuSign = defineMessages({
  title: {
    id: 'gofre.Settings.Verifactu.connection.dialog.title',
  },
  text01: { id: 'gofre.Settings.Verifactu.connection.dialog.text01' },
  text02: { id: 'gofre.Settings.Verifactu.connection.dialog.text02' },
});
